module.exports = __webpack_public_path__ + "img/zalo.e15decc4.png";